import transport from '../utils/axios';

// ==========================================
// Customer Returns (Backend Sprint 5 - already shipped)
// All endpoints expect a Sanctum bearer.
// ==========================================

export const getMyReturns = (params = {}) =>
    transport.get('/returns', { params });

export const getMyReturnById = (id) =>
    transport.get(`/returns/${id}`);

export const getReturnsForOrder = (orderId) =>
    transport.get(`/orders/${orderId}/returns`);

export const createReturn = (data) =>
    transport.post('/returns', data);

export const submitReturnShipping = (id, data) =>
    transport.post(`/returns/${id}/shipping`, data);

export const cancelMyReturn = (id, data = {}) =>
    transport.post(`/returns/${id}/cancel`, data);
